// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_BdV5QY","expanded":"ob_8WAJtV","content":"ob_DtDYCl","section_title":"ob_aaCJh1","section":"ob_sL5xSv","closeIcon":"ob_uDCpPE"};